module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/february-894882fa98bae450d39184d98b77ccb6.png";